const palette = {
  transparent: "#00000000",

  white: "#ffffff",
  white5: "rgba(255, 255, 255, 0.05)",
  white10: "rgba(255, 255, 255, 0.1)",
  white15: "rgba(255, 255, 255, 0.15)",
  white25: "rgba(255, 255, 255, 0.25)",
  white30: "rgba(255, 255, 255, 0.3)",
  white45: "rgba(255, 255, 255, 0.45)",
  white50: "rgba(255, 255, 255, 0.5)",
  white60: "rgba(255, 255, 255, 0.6)",
  white70: "rgba(255, 255, 255, 0.7)",
  white75: "rgba(255, 255, 255, 0.75)",
  white80: "rgba(255, 255, 255, 0.8)",
  white85: "rgba(255, 255, 255, 0.85)",
  white90: "rgba(255, 255, 255, 0.9)",
  white95: "rgba(255, 255, 255, 0.95)",

  black: "rgba(0, 0, 0, 1)",
  black5: "rgba(0, 0, 0, 0.05)",
  black10: "rgba(0, 0, 0, 0.1)",
  black15: "rgba(0, 0, 0, 0.15)",
  black20: "rgba(0, 0, 0, 0.2)",
  black30: "rgba(0, 0, 0, 0.3)",
  black45: "rgba(0, 0, 0, 0.45)",
  black50: "rgba(0, 0, 0, 0.5)",
  black60: "rgba(0, 0, 0, 0.6)",
  black70: "rgba(0, 0, 0, 0.7)",
  black85: "rgba(0, 0, 0, 0.85)",

  blue50: "#def9ff",
  blue80: "#98ebfe",
  blue100: "#6ce0fc",
  blue200: "#43d2f9",
  blue300: "#21c4f4",
  blue400: "#04b5ee",
  blue500: "#01a5e5",
  blue600: "#0296d9",
  blue700: "#0586cb",
  blue800: "#0977bb",
  blue900: "#0e69ab",

  gray50: "#F9F9F9",
  gray80: "#F5F5F5",
  gray100: "#EFEFF0",
  gray200: "#E7E7E8",
  gray300: "#D6D6D8",
  gray400: "#BFC0C2",
  gray500: "#A2A3A7",
  gray600: "#828488",
  gray700: "#606367",
  gray800: "#404346",
  gray900: "#222426",
};

export default palette;
